import { cn } from '@/utils/cn';

import { signColorClass } from './format';

// Shared table conventions for every reporting table, copied from the account page's
// TopPositionsCard so the two pages read as one product: a tinted header row with 10px tracked
// uppercase labels, 12px row padding, 24px edge padding, right-aligned tabular numerals, semibold
// cocoa-1000 primary values and sign-colored gains with a neutral fallback.

export const HEAD_CLASS = 'text-cocoa-500 text-[10px] font-semibold tracking-wider uppercase';
export const RIGHT_HEAD_CLASS = cn(HEAD_CLASS, 'text-right');
export const HEAD_ROW_CLASS = 'bg-cocoa-50 hover:bg-cocoa-50';

// On the <table>: row and edge padding without repeating px-6/py-3 on every cell.
export const TABLE_CLASS =
    'text-sm [&_td]:py-3 [&_td:first-child]:pl-6 [&_td:last-child]:pr-6 [&_th:first-child]:pl-6 [&_th:last-child]:pr-6';

// Title row of a card that holds a flush table (TopPositionsCard's header).
export const TABLE_CARD_HEADER_CLASS = 'flex flex-wrap items-center gap-4 p-4 lg:p-6';
export const TABLE_FOOTER_CLASS = 'text-cocoa-400 border-t px-6 py-3 text-xs';

export const NUMERIC_CELL = 'text-right text-sm tabular-nums';
export const MV_CELL = 'text-cocoa-1000 text-right text-sm font-semibold tabular-nums';

/** Numeric cell for a gain/loss figure — sign-colored, neutral cocoa when flat or unavailable. */
export const gainCell = (value: number | string | null | undefined) =>
    cn(NUMERIC_CELL, signColorClass(value) ?? 'text-cocoa-900');
